import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { CUSTOM_VEHICLE_MODEL_ID } from '../../common/constants';

export const GET_MODELS = gql`
  query GetVehicleModels($makeId: Int!, $year: Int!, $source: String) {
    vehicleModels(makeId: $makeId, year: $year, source: $source) {
      id
      name
    }
  }
`;

export default function useVehicleModels(makeId, year, source) {
  return useQuery(GET_MODELS, {
    skip: !makeId || !year,
    variables: {
      makeId,
      year,
      source,
    },
  });
}

export const useVehicleModelOptions = (models, activeModel) => useMemo(
  () => {
    const options = (models || []).map(({ id, name }) => ({
      label: name,
      value: id,
    }));

    if (activeModel && !options.find(m => m.label === activeModel)) {
      options.push({ label: activeModel, value: CUSTOM_VEHICLE_MODEL_ID });
    }

    return options;
  },
  [models, activeModel],
);
